import EmptyDataPlaceholder from "./EmptyDataPlaceholder";



export default EmptyDataPlaceholder;
